import React, { Component } from "react";
// Components
import TextField from "./TextField";

// Images import
import PlusIcon from "../assets/images/plus_icon.svg";
import Loader from "./loader";
import moment from "moment-timezone";

//Service import
import service from "../services";
//Validation import
import SimpleReactValidator from "simple-react-validator";
import AWS from "aws-sdk";
import UploadForm from "./UploadForm";
import ErrorPopUp from "../component/errorPopUp";
// import ErrorPopUp from "./errorPopUp";
import PopUpCustomAll from "../component/fpg/create/popUpCustomAll";
import commonImage from "../commonImage";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import TextEditor from "./TextEditor";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
let sub;
class TicketingCart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      getCartFooterDetails: [],
      getCartFooterDocs: [
        {
          _id: Math.random(),
          tileCTA: "",
          tileImage: "",
          tileTitle: "",
          tileURL: ""
        }
      ],
      imagePreloader: false,
      loaderFlag: false,
      getid: "",
      fname: "",
      lname: "",
      updatedAt: moment.utc().subtract(360, "minutes"),
      cartBannerTitle: EditorState.createEmpty(),
      isTicketingCartEdited: false,
    };
    this.validator = new SimpleReactValidator({autoForceUpdate: this,
      validators: {
        urlValidation: {// name the rule
          message: "Please use a valid name of the :attribute",
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val,/^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/) && params.indexOf(val) === -1
          },
          required: false // optional
        }
      }
    });
    this.apiserve = new service();
  }

  markTicketingCartEdited = () => {
    this.setState({ isTicketingCartEdited: true });
  };

  updateState = (newState, callback) => {
    this.setState(newState, () => {
      this.markTicketingCartEdited();
      if (callback) callback();
    });
  };

  onEditorStateChangecartBannerTitle = cartBannerTitle => {
    this.updateState({ cartBannerTitle });
  };

  componentDidMount = async () => {
    this.getCartFooter();
    this.getCartFooterEvent();
    this.setState({
      loaderFlag: true
    });
  };

  getCartFooterEvent = () => {
    sub = this.apiserve.getevent().subscribe(response => {
      switch (response.event) {
        case "ticketCms|cartFooter|getList":
          if (!response.error) {
            var getid =
              response &&
              response.data &&
              response.data.docs.map(item => {
                return item._id;
              });
            var getCartFooterDocs =
              response &&
              response.data &&
              response.data.docs[0] &&
              response.data.docs[0].tile.map((item, i) => {
                var List = {
                  _id: Math.random(),
                  tileCTA: item.tileCTA,
                  tileImage: item.tileImage,
                  tileTitle: item.tileTitle,
                  tileURL: item.tileURL
                };
                return List;
              });
            if (getCartFooterDocs) {
              this.setState({
                getCartFooterDetails: response.data,
                getCartFooterDocs:
                  getCartFooterDocs !== undefined ? getCartFooterDocs : this.state.getCartFooterDocs,
                error: response.data.error,
                getid: getid[0],
                loaderFlag: false,
                fname: response?.data?.docs[0].updatedBy?.fname,
                lname: response?.data?.docs[0].updatedBy?.lname,
                updatedAt: moment.tz(response.data.docs[0].updatedAt, "US/Mountain")
              });
              const cartBannerHtml = response.data?.docs[0]?.cartBannerTitle ?? '';
              const bannerBlocks = htmlToDraft(cartBannerHtml);
              const bannerContentState = ContentState.createFromBlockArray(bannerBlocks.contentBlocks, bannerBlocks.entityMap);
              this.setState({ cartBannerTitle: EditorState.createWithContent(bannerContentState) });
            } else this.setState({ loaderFlag: false });
          } else this.setState({ loaderFlag: false });

          break;
        case "ticketCms|cartFooter|edit":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error
            });
          } else {
            this.setState({ loaderFlag: false }, () => {
              this.setState({ isTicketingCartEdited: false });
              this.apiserve.success("CartFooter updated successful.");
            });
            this.getCartFooter();
          }
          break;
      }
    });
  };

  getCartFooter = () => {
    this.apiserve.sendevent("ticketCms|cartFooter|getList", {});
  };
  validateModel = () => {
    this.setState({
      errorMsg: false
    });
  };

  handleChange = (e, id) => {
    const { name, value } = e.target;
    const getCartFooterDocs = Object.assign([], this.state.getCartFooterDocs).map(m => {
      if (m._id === id) m[name] = value;
      return m;
    });
    this.updateState({ getCartFooterDocs });
  };

  onChangeFile(e, id) {
    // e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState(
        {
          file: file
          // base64: file,
        },
        () => {
          const fileList = Math.round(file && file.size / 1024);
          if (fileList >= 2048) {
            this.setState({
              errorMsg: true,
              errorMsgShow: "Please upload a file smaller than 2 MB"
            });
            return false;
          }
          if (
            (file && file.type === "image/png") ||
            (file && file.type === "image/jpg") ||
            (file && file.type === "image/jpeg")
          ) {
            setTimeout(() => {
              this.imageUpload(file, id,event.target.result);
            }, 0);
          } else {
            this.setState({
              errorMsg: true,
              errorMsgShow: "Please upload a file for PNG,JPG or JPEG"
            });
          }
        }
      );
    };
  }

  submitFn = async e => {
    e.preventDefault();
    if (this.validator.allValid()) {
      const cartBannerRaw = convertToRaw(this.state.cartBannerTitle.getCurrentContent());
      const cartBannerTitleHtml = draftToHtml(cartBannerRaw);
      this.setState({ loaderFlag: true });
      const { getCartFooterDocs } = this.state;
      let data = getCartFooterDocs.map(item => {
        var dataList = {
          id: item._id,
          tile: item.tile
        };
        return dataList;
      });
      getCartFooterDocs.map(item => {
        // const {_id }=item;
        // item.id = _id;
        delete item._id;
      });
      // var obJ ={}
      // let id = this.state.getid.forEach(e => {
      //   var ee = e.split(':')
      //   Reflect.set(obJ, ee[0],ee[1])
      // })
      let updateCart = {
        id: this.state.getid,
        tile: getCartFooterDocs,
        cartBannerTitle: cartBannerTitleHtml
      };
      this.apiserve.sendevent("ticketCms|cartFooter|edit", updateCart);
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  imageUpload = (file, id, img) => {
    const imagePreloaderId = `imagePreloader_${id}`;
    const newState = { ...this.state };
    newState[imagePreloaderId] = true;
    this.setState(newState);
    var fileSet= commonImage(file, false,'',img)
    fileSet.then((value) => {
      //   this.setState({

      //     imagePreloader: false,
      //   });
      this.state.getCartFooterDocs.forEach(sponsorList => {
        if (sponsorList._id === id) {
          const imagePreloaderId = `imagePreloader_${id}`;
          const newState = { ...this.state };
          newState[imagePreloaderId] = false;
          newState.isTicketingCartEdited = true;
          this.setState(newState);
          sponsorList.tileImage = value || "";
        }
      });
      this.setState({});
    });
  };

  cancelBTN = e => {
    e.preventDefault();
    window.location.reload();
    // this.props.history.push({pathaname: '/ticketing'})
  };

  onDeleteImagePopup = e => {
    const getCartFooterDocs = Object.assign([], this.state.getCartFooterDocs).map(image => {
      if (image._id === this.state.deleteId) image.tileImage = "";
      return image;
    });
    this.updateState({ getCartFooterDocs, deleteImagePopup: false });
  };
  deleteImage = id => this.setState({ deleteImagePopup: true, deleteId: id });
  closeAdminUser = () => this.setState({ deleteImagePopup: false, deleteId: "" });

  render() {
    const { updatedAt } = this.state;
    var updatedBy = `${this.state.fname?this.state.fname : ''} ${this.state.lname ? this.state.lname : ''}`;
    return (
      <>
        <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
          {/* <Link className="back_link"> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black"/> </svg> Back to List</Link> */}
          <p></p>
          <p className="update_date">
            Last Update: {updatedAt.format("hh:mm A") ? updatedAt.format("hh:mm A") : ''} MT -{updatedAt.format("MM/DD/YYYY") ? updatedAt.format("MM/DD/YYYY") : ''} Last Updated By:{" "}
            {updatedBy === undefined ? "" : updatedBy}
          </p>
        </div>
        <div className="ticketing_content fpg_tabcontent">
          <div className="field_row horizontal_field">
            <div className="field_row_inner">
              <label className="mr_15">Cart Banner Text</label>
              <div className="field_input relative editor_wrapper" style={{maxWidth: '400px'}}>
                <TextEditor
                  name="cartBannerTitle"
                  editorState={this.state.cartBannerTitle}
                  value={this.state.cartBannerTitle}
                  onEditorStateChange={e => this.onEditorStateChangecartBannerTitle(e)}
                  fpgerror={this.validator.message('cartBannerTitle', this.state.cartBannerTitle.getCurrentContent().getPlainText(), 'required')}
                />
              </div>
            </div>
          </div>
          <h4 className="uppercase ticket_page_title">Start Exploring</h4>
          {this.state.getCartFooterDocs.map((item, i) => {
            const imagePreloaderState = `imagePreloader_${item._id}`;
            return (
              <div className="home_page_title_wpr ">
                <div className="title_header">
                  <p>Tile {i + 1}</p>
                </div>
                <div className="title_content">
                  <>
                    <div className="title_content_img">
                      <div className="title_content_img_box loader-main">
                        {this.state[imagePreloaderState] ? (
                          <Loader />
                        ) : (
                          <img
                            src={
                              item.tileImage
                                ? this.apiserve.imageUrl + item.tileImage
                                : item.tileURL
                                ? item.tileURL
                                : "/images/image-placeholder.png"
                            }
                            onError={e => {
                              e.target.src = "/images/image-placeholder.png";
                            }}
                          />
                        )}
                        <UploadForm
                          item={item}
                          handleImage={e => this.onChangeFile(e, item._id)}
                          deleteImage={() => this.deleteImage(item._id)}
                        />
                        <span className="error_msg">{this.props.imageErr}</span>
                      </div>
                      <span className="error_note">Max size 2MB</span>
                    </div>
                    <div className="title_content_form">
                      <div className="form_group form_group_input">
                        <div className="field_row_inner">
                          <label>Tile Title</label>
                          <div className="field_input relative">
                            <textarea
                              name="tileTitle"
                              value={item.tileTitle}
                              id={item._id}
                              label="Tile Title"
                              type="text"
                              onChange={e => this.handleChange(e, item._id)}
                            ></textarea>
                          <span style={{ color: "red" }}>
                            {this.validator.message("Tile Title " + i, item.tileTitle, "required")}
                          </span>
                          </div>
                        </div>
                        {/* <TextField
                        name="tileTitle"
                        value={item.tileTitle}
                        id={item._id}
                        label="Tile Title"
                        type="text"
                        onChange={(e) => this.handleChange(e, item._id)}
                      /> */}
                        {/* <span className="error_msg">Please enter tile title.</span>            "/user.png"                                     */}
                      </div>

                      <div className="form_group form_group_input form_group_input_cta">
                        <TextField
                          name="tileCTA"
                          value={item.tileCTA}
                          id={item._id}
                          label="Tile CTA"
                          type="text"
                          onChange={e => this.handleChange(e, item._id)}
                          fpgerror={this.validator.message("Tile CTA " + i, item.tileCTA, "required")}
                        />
                      </div>
                      <>
                        <div className="form_group form_group_input">
                          <TextField
                            name="tileURL"
                            // defaultValue={item.tileURL}
                            id={item._id}
                            label="Tile URL"
                            type="text"
                            value={item.tileURL}
                            onChange={e => this.handleChange(e, item._id)}
                            fpgerror={this.validator.message("tile URL " + i, item.tileURL, "required|urlValidation")}
                          />
                        </div>
                      </>
                    </div>
                  </>
                </div>
              </div>
            );
          })}
          <div className="text_center field_row w_100 buttons_outer">
            <button className="uppercase" onClick={this.cancelBTN}>
              CANCEL
            </button>
            {/* <button className="uppercase prev_btn">PREviEW</button> */}
            <button disabled={this.state.loaderFlag || (this.state.getid ? !this.state.isTicketingCartEdited : false)} className={`uppercase ${this.state.loaderFlag || (this.state.getid ? !this.state.isTicketingCartEdited : false) ? '' : 'active'}`} type="button" onClick={e => this.submitFn(e)}>
              SAVE
            </button>
          </div>
          {this.state.errorMsg && (
            <ErrorPopUp errorMsg={this.state.errorMsgShow} errorMsgPopup={this.validateModel} />
          )}
          {this.state.deleteImagePopup ? (
            <PopUpCustomAll
              HeaderName="Delete Image?"
              insideDetails="Are You Sure ?"
              insideData="You want to delete this image"
              popupState={() => this.closeAdminUser()}
              yesPopUp={() => this.onDeleteImagePopup()}
            />
          ) : (
            ""
          )}
          {this.state.loaderFlag && <Loader />}
        </div>
      </>
    );
  }
}
export default TicketingCart;
